<template>
  <v-dialog persistent v-model="show" width="1200">
    <v-card>
      <v-card-title>
        <span class="headline">ポップアップ</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="submit" class="ml-2">保存</v-btn>
        <v-btn @click="remove" class="ml-2">削除</v-btn>
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>
      <v-data-table
        :headers="headers"
        :items="inv.packages.filter((p) => p.poId === normalId)"
        :loading="loading"
        class="inline-edit"
        hide-actions
        item-key="id"
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td width="150">{{ props.item.invoiceNo }}</td>
          <td width="150">{{ props.item.poNo }}</td>
          <td width="200">
            {{ props.item.productCode }}:{{ props.item.productName }}
          </td>
          <td width="200">{{ props.item.skuCode }}</td>
          <td width="100">{{ props.item.paid === 1 ? '有償' : '無償' }}</td>
          <td width="100">
            <v-text-field v-model="props.item.cartonStartNo" />
          </td>
          <td width="100">
            <v-text-field v-model="props.item.cartonEndNo" />
          </td>
          <td width="100">
            <v-text-field v-model="props.item.perCartonQty" />
          </td>
          <td width="100">
            <v-text-field v-model="props.item.totalQty" />
          </td>
          <td width="100">{{ props.item.currencyCode }}</td>
          <td width="100">{{ props.item.unitPrice }}</td>
          <!-- <td>
                <v-btn @click="removePkg(props.item)">X</v-btn>
          </td>-->
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['conflictId', 'normalId'],
  data: () => ({
    show: false,
    inv: {
      packages: [],
    },
    pkg: {},
    selected: [],
    loading: false,
    headers: [
      { text: '', value: '', sortable: false },
      { text: 'INV NO', value: 'invoiceNo', sortable: false },
      { text: 'P/O NO', value: 'poNo', sortable: false },
      { text: '品種', value: 'productCode', sortable: false },
      { text: '品番', value: 'skuCode', sortable: false },
      { text: '有償/無償', value: 'paid', sortable: false },
      { text: 'Carton Start No', value: 'cartonStartNo', sortable: false },
      { text: 'End No', value: 'cartonEndNo', sortable: false },
      { text: '入り数', value: 'perCartonQty', sortable: false },
      { text: '数量', value: 'totalQty', sortable: false },
      { text: '外貨', value: 'currencyCode', sortable: false },
      { text: '単価', value: 'unitPrice', sortable: false },
    ],
  }),
  methods: {
    remove() {
      if (
        this.inv.packages.filter((p) => p.poId === this.normalId).length ===
        this.selected.length
      ) {
        this.$message('', '直接I/V取消してください.')
      } else {
        this.inv.packages = this.inv.packages.filter(
          (i) => this.selected.indexOf(i) === -1
        )
        this.selected = []
      }
    },
    submit() {
      this.$emit('submit', this.inv)
      this.show = false
    },
    popup(inv) {
      this.show = true
      this.inv = inv
    },
    removePkg(pkg) {
      pkg.removed = true
    },
  },
}
</script>
